import { CreditCard } from 'lucide-react'

import { Button, Card, Icon } from 'ui'
import { formatCurrency } from 'utils/billing'

import { intervalUnit, UpgradeFeatureList } from './UpgradePresentation'

const CONTACT_EMAIL = 'accountmanagement@expandrive.com'
const CONTACT_PHONE = '+1 (510) 500-0245'

export const ActivationSummary = ({ account = {}, brand = {}, onContinue, upgrade = {} }) => {
  const amount = formatCurrency(upgrade.amount, upgrade.currency)
  const unit = intervalUnit(upgrade.interval)
  const planName = account.plan_name || account.planName
  const brandName = brand.name || 'ExpanDrive'
  const brandPhone = brand.phone || CONTACT_PHONE

  return (
    <div>
      <Card className="tw:overflow-hidden">
        <div className="tw:grid tw:grid-cols-[minmax(0,1.9fr)_minmax(280px,0.9fr)] tw:shell:grid-cols-1">
          <div className="tw:p-5 tw:mobile:p-4">
            <div className="tw:text-sm tw:font-semibold tw:text-foreground-muted">ExpanDrive {planName || 'subscription'}</div>
            <div className="tw:mt-3 tw:flex tw:flex-wrap tw:items-end tw:gap-x-2 tw:gap-y-1">
              <span className="tw:text-5xl tw:font-light tw:text-foreground-strong">{amount}</span>
              <span className="tw:pb-1 tw:text-foreground-subtle">/{unit}</span>
            </div>
            <p className="tw:mt-4 tw:max-w-[72ch] tw:text-foreground-muted">
              Server Edition · Web Management Console · priority support
            </p>

            <div className="tw:my-6 tw:border-t tw:border-default" />
            <UpgradeFeatureList className="tw:grid-cols-2 tw:gap-x-6 tw:gap-y-4 tw:mobile:grid-cols-1" />
          </div>

          <aside className="tw:border-l tw:border-default tw:bg-surface-muted tw:p-5 tw:shell:border-l-0 tw:shell:border-t tw:mobile:p-4">
            <div className="ds-helper">Due today</div>
            <div className="tw:mt-2 tw:text-4xl tw:font-light tw:text-foreground-strong">{amount}</div>
            <Button
              className="tw:mt-5 tw:w-full"
              icon={<Icon as={CreditCard} />}
              onClick={onContinue}
              type="button"
              variant="cta"
            >
              Continue to Payment
            </Button>
          </aside>
        </div>
      </Card>

      <p className="ds-helper tw:mt-8 tw:border-t tw:border-default tw:pt-4 tw:text-center">
        Please contact {brandName} to make changes to your account. You can reach us by telephone at{' '}
        <a className="tw:underline" href={`tel:${brandPhone.replace(/[^+\d]/g, '')}`}>{brandPhone}</a>
        {' '}or email <a className="tw:underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </div>
  )
}

export default ActivationSummary
